import Action from '../Action';
import LeadsService from '../../services/LeadsService';
import { message } from 'antd';

export function fetchDealers() {
	return (dispatch) => {
		LeadsService.get()
			.then((data) => {
				dispatch({ type: Action.FETCH_DEALERS, dealers: data.data });
			})
			.catch((error) => message.error('Failed to fetch dealers!'));
	};
}

export function fetchDealerCars(query) {
	return (dispatch) => {
		LeadsService.search(query)
			.then((data) => {
				dispatch({ type: Action.FETCH_DEALER_CARS, dealerCars: data.data });
			})
			.catch((error) => message.error('Failed to fetch dealer cars!'));
	};
}

export function fetchStats(query) {
	return (dispatch) => {
		LeadsService.stats(query)
			.then((data) => {
				dispatch({ type: Action.FETCH_STATS, stats: data.data });
			})
			.catch((error) => message.error('Failed to fetch dealer cars!'));
	};
}
